import { render } from "./doneRemove.vue?vue&type=template&id=5d4485c9"
import script from "./doneRemove.vue?vue&type=script&lang=js"
export * from "./doneRemove.vue?vue&type=script&lang=js"

import exportComponent from "F:\\N\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__